import React from 'react'
import { toDocumentFormat } from '../../utils/dateHelper'
import moment from 'moment'
import { toCurrencyFormat } from '../../utils/utils'
import _ from 'lodash'

export const TourPackageCard = ({ tourPackage, options = {} }) => {
    const { showPrice = true } = options;
    return (
        <div className='tour-package'>
            <div className='tour-package-image'>
                <img src={tourPackage.photo} alt={tourPackage.name} />
            </div>
            <div className='tour-package-content'>
                <h1>{tourPackage.name}</h1>
                <p className='text-sm' dangerouslySetInnerHTML={{ __html: tourPackage.description }} />
                <div className='gap-2 mb-4'>
                    <div className='mb-2'>
                        <strong className=''>Дата поездки:</strong>
                    </div>
                    <div>
                        <span>{toDocumentFormat(tourPackage.startDate)} - {toDocumentFormat(tourPackage.endDate)} </span>
                        <span>
                            ({moment(tourPackage.endDate).diff(moment(tourPackage.startDate), 'days')} <span className=''>ночей</span>)
                        </span>
                    </div>
                </div>
                {showPrice && (
                    <div className='tour-package-price mb-8'>
                        <strong>Общая стоимость тура: </strong>
                        <div className='mt-1'>
                        <strong className='text-2xl'>{_.get(tourPackage, 'price') ?
                            toCurrencyFormat(_.get(tourPackage, 'price', 'Цена отсутсвует'), 'USD') :
                            'Цена отсутсвует'}</strong>
                        <span className='text-xs text-gray-500 ml-4'>{_.get(tourPackage, 'totalPriceInKZT') ? toCurrencyFormat(_.get(tourPackage, 'totalPriceInKZT'), 'KZT') : ''}</span>
                    </div>
                    </div>
                )}
            </div>
        </div>
    )
}
